@if (status === 2) {
  <zwi-section-headline>You converted your account to a ministry account for {{ ministry.name }}!</zwi-section-headline>
  <zwi-widget>
    <button mat-flat-button color="primary" routerLink="/studio/upload">Add sermons</button>
  </zwi-widget>
} @else {
  <zwi-signup-ministry buttonLabel="Convert account" (updateMinistry)="updateMinistry($event)"></zwi-signup-ministry>
}



